import PropTypes from 'prop-types';
import './style.scss';

export default function FormSelect({
  id = null,
  labelClass = '',
  wrapClass = '',
  selectClass = '',
  optionClass = '',
  errorLabelClass = '',
  label = null,
  name = null,
  onChange = () => { },
  required = false,
  options = [],
  optionsValueKey = '',
  optionsNameKey = '',
  value = '',
  disabledValues = [],
  blankOptionName = '',
  blankOptionValue = '',
  hiddenBlankOption = true,
  disabledBlankOption = true,
  errorMessage = null,
  ...props
}) {

  const isOptionsArrOfStrings = options.every((item) => typeof item === 'string');
  const elementLabel = (
    <label htmlFor={id} className={`select__label ${labelClass}`}>
      {label}
    </label>
  );
  const errorLabel = (
    <label htmlFor={id} className={`input__label input__label--error ${errorLabelClass}`}>
      {errorMessage}
    </label>
  );
  const renderStringOptions = () =>
    options.map((option, index) => (
      <option key={`${index}-${id}`} className={`select__option ${optionClass}`} value={option}>
        {option}
      </option>
    ));
  const renderObjOptions = () =>
    options.map((option, index) => {
      const isDisabled = disabledValues.includes(option[optionsValueKey]);
      return (
        <option
          key={`${index}-${id}`}
          className={`select__option ${optionClass}`}
          disabled={isDisabled}
          value={option[optionsValueKey]}>
          {option[optionsNameKey] || option[optionsValueKey]}
        </option>
      );
    });

  return (
    <fieldset className={`select__wrap ${wrapClass}`}>
      {label && elementLabel}
      <select
        id={id}
        name={name}
        required={required}
        className={`select__dropdown ${selectClass}`}
        value={value || blankOptionValue}
        onChange={(e) => {
          onChange(e);
        }}
        {...props}>
        {blankOptionName && (
          <option
            disabled={disabledBlankOption}
            value={blankOptionValue}
            hidden={hiddenBlankOption}>
            {blankOptionName}
          </option>
        )}
        {isOptionsArrOfStrings ? renderStringOptions() : renderObjOptions()}
      </select>
      {errorMessage && errorLabel}
    </fieldset>
  );
}

FormSelect.propTypes = {
  id: PropTypes.string,
  labelClass: PropTypes.string,
  wrapClass: PropTypes.string,
  selectClass: PropTypes.string,
  optionClass: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  optionsNameKey: PropTypes.string,
  optionsValueKey: PropTypes.string,
  options: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.arrayOf(PropTypes.string)
  ]).isRequired,
  value: PropTypes.string,
  disabledValues: PropTypes.array,
  blankOptionName: PropTypes.string,
  blankOptionValue: PropTypes.any,
  hiddenBlankOption: PropTypes.bool,
  disabledBlankOption: PropTypes.bool
};
